import { Badge, Button, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import EmployeeAvatar from 'components/@home/EmployeeAvatar';
import { usePendingSignatureCount } from 'components/@home/@signatures/pendingSignatures';
import { bool } from 'prop-types';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import auth from 'store/app/auth/action';
import settingsDrawer from 'store/app/ui/drawers/settings/action';
import authEmployee from 'store/selectors/authEmployee';
import useActions from 'utils/useActions';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
};

const UserMenu = ({ disabled = false }) => {
  const [openSettings, logout] = useActions([settingsDrawer.open, auth.logout]);

  const employee = useSelector(authEmployee);
  const pendingSignatures = usePendingSignatureCount();

  if (!employee?._id) {
    return (
      <Button onClick={logout} variant="contained" color="primary">
        Logout
      </Button>
    );
  }

  return (
    <Box sx={styles.root}>
      <IconButton onClick={openSettings} color="inherit" disabled={disabled} size="large">
        <Badge variant="dot" color="primary" overlap="circular" invisible={pendingSignatures < 1}>
          <EmployeeAvatar employee={employee} />
        </Badge>
      </IconButton>
    </Box>
  );
};

UserMenu.propTypes = {
  disabled: bool,
};

export default memo(UserMenu);
